// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:1024px){.left-flex[data-v-6e8955a0]{flex:66}.left-flex-max-w[data-v-6e8955a0]{max-width:66%}.right-flex[data-v-6e8955a0]{flex:34}.ogray-backdrop[data-v-6e8955a0]{width:125.4rem;height:50rem}.osignup-box-container[data-v-6e8955a0]{min-height:58rem}.osignup-box-container>div[data-v-6e8955a0]{top:6.1rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
